import Form from 'semantic-ui-react/dist/commonjs/collections/Form'
export default Form
